import { FormBackgroundTheme } from "@simplyk/common";

import type { BurstType } from "./Burst";

export function formBackgroundThemeToBurstType(theme: FormBackgroundTheme | null | undefined): BurstType | "none" {
  switch (theme) {
    case FormBackgroundTheme.Hearts:
    case FormBackgroundTheme.GivingTuesday:
      return "heart";
    case FormBackgroundTheme.Sparkles:
      return "sparkle";
    case FormBackgroundTheme.Music:
      return "note";
    case FormBackgroundTheme.Cards:
      return "card-die";
    case FormBackgroundTheme.Connectors:
      return "connector";
    case FormBackgroundTheme.Faith:
      return "light";
    case FormBackgroundTheme.Sports:
      return "ball";
    case FormBackgroundTheme.Winter:
      return "snowflake";
    case FormBackgroundTheme.Fall:
      return "leaf";
    case FormBackgroundTheme.Pride:
      return "confetti";
    default:
      return "none";
  }
}

export function formBackgroundThemeToBurstTypeOrHeart(theme: FormBackgroundTheme | null | undefined): BurstType {
  const burstType = formBackgroundThemeToBurstType(theme);
  return burstType === "none" ? "heart" : burstType;
}
